// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CloseButton[data-v-0ead5f80]{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
